import axios from "axios";
import React from "react";
import { jsonHeader } from '../util/GeneralUtil'
import * as BullCache from "../util/BullCache";

const apiUrl = process.env.REACT_APP_API_URL;


    var user = BullCache.getFromCache("user");

async function AddClosingRate(payload) {
    const result = await axios.post(apiUrl + "/script/add/closingrate", payload, {
        headers: jsonHeader}
    );
    return result.data || [];
}

async function getClosingrate(payload) {
    const result = await axios.post(apiUrl + "/script/get/closingrate", payload, {
        headers: jsonHeader}
    );
    return result.data || [];
}

async function UploadClosingRate(payload) {
    const result = await axios.post(`${apiUrl}/script/upload/closingrate/${user.adminId}`, payload, {
    }
    );
    return result.data || [];
}

async function UpdateClosingRate(payload) {
    const result = await axios.post(apiUrl + "/script/update/closingrate", payload, {
        headers: jsonHeader}
    );
    return result.data || [];
}

async function GenerateBill(payload) {
    const result = await axios.post(apiUrl + "/admin/generatebill", payload, {
        headers: jsonHeader}
    );
    return result.data || [];
}

async function fetchClosingRates(payload) {
    const result = await axios.post(apiUrl + "/script/fetch/closingrates", payload, {
        headers: jsonHeader}
    );
    return result.data || [];
}

export const ClosingRateService = {
    getClosingrate,
    UploadClosingRate,
    UpdateClosingRate,
    AddClosingRate,
    GenerateBill,
    fetchClosingRates
}